<header class="page-header">
  <div class="page-header__row">
    <h1>Validate filing</h1>
    <span class="badge">Beta</span>
  </div>
  <p class="lede">
    Upload a report package (.zip), legacy .xbrl/.xml, or CSV/JSON files. Validation runs against
    the bundled EBA RF 4.2 taxonomy in your browser.
  </p>
</header>

<app-file-upload-zone [disabled]="busy()" (filesSelected)="onFiles($event)" />

@if (filename()) {
  <p class="meta">File: <strong>{{ filename() }}</strong></p>
}

<app-job-status-line [phase]="phase()" />

@if (error()) {
  <p class="error">{{ error() }}</p>
}

@if (counts(); as c) {
  <div class="summary">
    <span class="pill pill--error">{{ c.error }} errors</span>
    <span class="pill pill--warn">{{ c.warning }} warnings</span>
    <span class="pill">{{ c.info }} info</span>
    @if (totalMs() !== null) {
      <span class="pill pill--muted">{{ totalMs() }} ms</span>
    }
  </div>
}

@if (messages().length) {
  <section class="messages">
    <h2>Messages</h2>
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Level</th>
            <th>Code</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          @for (msg of messages(); track $index) {
            <tr>
              <td>{{ msg.level }}</td>
              <td>{{ msg.code }}</td>
              <td>{{ msg.text }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
}
